import script from "./UserGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserGroup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__